import React from "react";
import { Link } from "react-router-dom";

function Support() {
  return (
    <div>
      <div className="px-4 bg-gradient-to-b from-green-900 via-zinc-900 block m-auto to-black">
        <div className="sm:px-5 md:px-20 md:py-2 lg:px-36 xl:px-80">
          <div className="pt-4 md:pt-12">
            <p className="uppercase font-semibold text-lg text-gray-400">
              spotify support
            </p>
            <h1 className="font-bold text-4xl mt-4 leading-loose md:leading-loose text-white md:text-6xl xl:text-7xl xl:leading-loose">
              How can we help you?
            </h1>
            <h4 className="font-bold mt-14 text-lg text-gray-400">
              <span className="cursor-pointer underline text-white mr-1">
                Log in
              </span>
              for faster help
            </h4>
          </div>
          <div className=" mt-11">
            <div className="pl-2 h-12 flex items-center gap-2 bg-white text-xl border rounded ">
              <ion-icon name="search-outline"></ion-icon>
              <input
                type="text"
                placeholder="Search"
                className=" w-full placeholder:text-black placeholder:text-base placeholder:font-medium inset-0 focus:outline-none"
              />
            </div>
          </div>

          <div className="pb-20 mt-10 grid grid-cols-2 gap-3 md:grid-cols-3 text-center">
            <div className=" bg-gradient-to-b from-fuchsia-900 via-fuchsia-900 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>Payment Help</p>
            </div>
            <div className="bg-gradient-to-b from-red-900 via-red-900 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>Plan Help</p>
            </div>
            <div className="bg-gradient-to-b from-orange-900 via-orange-900 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>App Help</p>
            </div>
            <div className="bg-gradient-to-b from-green-900 via-green-900 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>Device Help</p>
            </div>
            <div className="bg-gradient-to-b from-zinc-700 via-zinc-800 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>Safety & Privacy</p>
            </div>
            <div className="bg-gradient-to-b from-cyan-300 via-cyan-700 to-black text-white font-semibold h-20 py-4 px-2 rounded">
              <p>Account Help</p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 sm:px-10 py-8 md:px-24 lg:px-40 m-auto lg:pt-10 xl:px-80 bg-zinc-800">
        <h1 className="text-white font-bold text-2xl">Quick help</h1>

        <ul className="mt-14 mb-8 text-white font-semibold space-y-12">
          <li className="flex items-center justify-between hover:underline">
            <Link to="/">Can't reset password </Link>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </li>
          <li className="flex items-center justify-between hover:underline">
            <Link to="/">Can't remember login details </Link>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </li>
          <li className="flex items-center justify-between hover:underline">
            <Link to="/">Facebook login help</Link>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </li>
          <li className="flex items-center justify-between hover:underline">
            <Link to="/">Payment methods </Link>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </li>
          <li className="flex items-center justify-between hover:underline">
            <Link to="/">Start or join Premium Family </Link>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </li>
        </ul>
      </div>

      <div className="bg-zinc-900 px-3 py-24 sm:px-8 md:px-20 text-center align-middle">
        <h1 className="text-white font-bold text-2xl md:text-4xl">
          Visit our Community
        </h1>
        <div className="mt-6">
          <p className="text-white text-sm font-medium">
            Have questions? Find answers from our worldwide Community of expert
            fans!
          </p>
          <button className="mt-6 lg:mt-9 bg-green-500 px-5 py-3 lg:py-3 rounded-3xl text-sm font-bold uppercase hover:transform translate duration-800 hover:scale-110">
            <Link to="/signup">Go to Community</Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Support;
